/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoiceLineProduct = {
    InvoiceLineProductFreePlan: 'free_plan',
    InvoiceLineProductStoreSubscriptionFee: 'store_subscription_fee',
    InvoiceLineProductSupplierSubscriptionFee: 'supplier_subscription_fee',
    InvoiceLineProductSupplierOrderFee: 'supplier_order_fee',
    InvoiceLineProductRetailerSubscriptionFee: 'retailer_subscription_fee'
} as const;
export type InvoiceLineProduct = typeof InvoiceLineProduct[keyof typeof InvoiceLineProduct];


// @ts-ignore
export function InvoiceLineProductFromJSON(json: any): InvoiceLineProduct {
    return InvoiceLineProductFromJSONTyped(json, false);
}

// @ts-ignore
export function InvoiceLineProductFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceLineProduct {
    return json as InvoiceLineProduct;
}

// @ts-ignore
export function InvoiceLineProductToJSON(value?: InvoiceLineProduct | null): any {
    return value as any;
}

